import type {ReactElement} from 'react';
import React from 'react';
import {CustomListItem} from '@Components/contextual-menu/components/custom-list-item';
import './intro-animation-list-item.scss';
import type {AnimationType} from '@PosterWhiteboard/classes/item-animation.class';

interface IntroAnimationListItemProps {
  type: AnimationType;
  onClick(type: AnimationType): void;
  selectedAnimation: AnimationType;
  text: string;
  svg: ReactElement<any>;
}

export function IntroAnimationListItem({...props}: IntroAnimationListItemProps): ReactElement<any> {
  return (
    <CustomListItem
      id={props.type}
      onClick={(): void => {
        if (props.type === props.selectedAnimation) {
          return;
        }
        props.onClick(props.type);
      }}
      className={`intro-animation-svg-container ${props.type === props.selectedAnimation ? '-selected' : ''}`}
      svgOrIcon={props.svg}
      isSelected={props.type === props.selectedAnimation}
      text={props.text}
    />
  );
}
